import { Component, OnInit, Input, AfterViewChecked  } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import { Documento } from './documento';
import { DocumentoService } from './documento.service';

import { TipoService } from './../tipos/tipo.service';
import { Tipo } from './../tipos/tipo';

import { TipoCertificadoService } from './../tipos_certificados/tipo_certificado.service';
import { TipoCertificado } from './../tipos_certificados/tipo_certificado';

import { Variavel } from './../variaveis/variavel';
import { Assinatura } from './../assinaturas/assinatura';

import { UnidadeService } from './../unidades/unidade.service';
import { Unidade } from './../unidades/unidade';

import { CentroService } from './../centros/centro.service';
import { Centro } from './../centros/centro';

import { GrupoService } from './../grupos/grupo.service';
import { Grupo } from './../grupos/grupo';
import { Utils } from './../shared/utils';

declare var Materialize:any;

@Component({
  selector: 'app-documentos',
  templateUrl: './editar.component.html',
  styleUrls: ['./documentos.component.css'],
  providers: [DocumentoService, TipoService, TipoCertificadoService, UnidadeService, CentroService, GrupoService, Utils]
})

export class EditarDocumentoComponent implements OnInit, AfterViewChecked  {
  documento: Documento;
  titulo: string = "Editar Documento";
  tipos: Tipo[];
  tipoCertificados: TipoCertificado[];
  unidades: Unidade[];
  centros: Centro[];
  grupos: Grupo[];
  passos: string[] = ['documento', 'variaveis', 'corpo', 'visualizar'];
  passo_atual: string = 'documento';
  variaveis_ativo: any[];
  showLoader: Boolean = true;
  exibirLocal: Boolean = true;
  public busy: Promise<any>;
  assinadores: any[] = [];

  constructor(
    private documentoService: DocumentoService,
    private tipoService: TipoService,
    private tipoCertificadoService: TipoCertificadoService,
    private unidadeService: UnidadeService,
    private centroService: CentroService,
    private grupoService: GrupoService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    private utils: Utils
  ) {
    this.documento = new Documento();
  }

  getDocumento(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];
      if(id !== undefined ){

        this.busy = this.documentoService.getDocumento(id)
          .then((documento) => this.exibir(documento));
      }
    });
  }

  exibir(documento: any): void{
    this.documento = documento;
    if (!this.documento.certificado.assinatura_digital) {
      this.documento.certificado.assinatura_digital = false;
    }
    this.verificaCorpo();
    if (this.documento.certificado.assinatura_digital) {
      this.carregarAssinadores();
    }
    this.showLoader = false;
  }

  addVariavel(): void{
    this.documento.variaveis.push(new Variavel());
  }

  addAssinatura():void{
    this.documento.certificado.assinaturas.push(new Assinatura());
  }

  getUnidades(): void{
    this.unidadeService.getUnidadesPorCentro(this.documento.centro_id)
        .then((response) => this.unidades = response);
  }

  getCentros(): void{
    this.centroService.getCentros()
        .then((response) => this.centros = response);
  }

  getGrupos(): void{
    this.grupoService.getAllGrupos()
        .then((response) => this.grupos = response);
  }

  removeVariavel(variavel: any): void{
    let indice = this.documento.variaveis.indexOf( variavel );
    this.documento.variaveis[indice].destroy = true;
    if(!this.documento.variaveis[indice].id){
      this.documento.variaveis.splice(indice, 1);
    }

  }

  removeAssinatura(assinatura: any): void{
    let indice = this.documento.certificado.assinaturas.indexOf( assinatura );
    this.documento.certificado.assinaturas[indice].destroy = true;
    if(!this.documento.certificado.assinaturas[indice].id){
      this.documento.certificado.assinaturas.splice(indice, 1);
    }
  }

  salvar(): void {
    if (!this.validarAssinaturas()) {
      return;
    }

    if(this.documento.id){
      this.busy = this.documentoService.saveDocumento(this.documento)
          .then(() => this.goBack());
    }
  }

  validarAssinaturas(): boolean {
    if (!this.documento.certificado.assinatura_digital) {
      return true;
    }

    if (!this.documento.grupo_id) {
      this.utils.flashMessage('Selecione o grupo do certificado antes de configurar assinaturas digitais.', 'warning');
      return false;
    }

    const assinaturas = this.documento.certificado.assinaturas.filter((a: Assinatura) => !a.destroy);
    if (assinaturas.length === 0) {
      this.utils.flashMessage('Informe ao menos um assinador.', 'warning');
      return false;
    }

    for (const assinatura of assinaturas) {
      if (!assinatura.usuario_id || !assinatura.posicao || !assinatura.cargo) {
        this.utils.flashMessage('Preencha assinador, posição e cargo em todas as assinaturas digitais.', 'warning');
        return false;
      }
    }

    return true;
  }

  carregarAssinadores(): void {
    if (!this.documento.grupo_id) {
      this.assinadores = [];
      return;
    }

    this.grupoService.getAssinadoresGrupo(this.documento.grupo_id)
      .then((response) => this.assinadores = response);
  }

  toggleTipoAssinatura(digital: boolean): void {
    if (!!this.documento.certificado.assinatura_digital === digital) {
      return;
    }

    this.documento.certificado.assinatura_digital = digital;
    this.limparAssinaturas();

    if (digital) {
      this.carregarAssinadores();
    }
  }

  limparAssinaturas(): void {
    let assinaturas: Assinatura[] = [];

    for (let assinatura of this.documento.certificado.assinaturas) {
      if (assinatura.id) {
        assinatura.destroy = true;
        assinaturas.push(assinatura);
      }
    }

    assinaturas.push(new Assinatura());
    this.documento.certificado.assinaturas = assinaturas;
  }

  onAssinadorChange(assinatura: Assinatura): void {
    const usuario = this.assinadores.find((u) => u.id == assinatura.usuario_id);
    if (usuario) {
      assinatura.nome = usuario.nome;
    }
  }

  upload(event: any, assinatura:Assinatura):void{
    let listaArquivo: FileList = event.target.files;
    let arquivo: File = listaArquivo[0];
    assinatura.arquivo = arquivo;
  }

  getTipoCertificados(): void{
    this.tipoCertificadoService.getTipos()
        .then((response) => this.tipoCertificados = response);
  }

  getTipos(): void{
    this.tipoService.getTipos()
        .then((response) => this.tipos = response);
  }

  goBack(): void {
     this.router.navigate(['/documentos']);
  }

  goHome(): void {
    this.router.navigate(['/']);
  }

  mudarLocal(): void{
    this.exibirLocal = false;
  }

  verificarArray(valor: any): boolean{
    return valor !== undefined && valor.length <= 0 ;
  }

  proximoPassos(): void{
    switch(this.passo_atual){
      case 'documento':
        this.passo_atual = 'variaveis';
        break;
      case 'variaveis':
        this.passo_atual = 'corpo';
        break;
      case 'corpo':
        this.passo_atual = 'visualizar';
        break;
    }
  }

  anteriorPassos(): void{
    switch(this.passo_atual){
      case 'visualizar':
        this.passo_atual = 'corpo';
        break;
      case 'variaveis':
        this.passo_atual = 'documento';
        break;
      case 'corpo':
        this.passo_atual = 'variaveis';
        break;
    }
  }

  verificaCorpo(): void{
    let variaveis = this.documento.variaveis;
    let i:any;
    let regex:any;
    let corpo:string;

    for( i in variaveis){
      regex = new RegExp("%" + variaveis[i].identificador +"%");

      corpo = this.documento.certificado.corpo;
      if(regex.test(corpo)){
        variaveis[i].usado = true;
      } else {
        variaveis[i].usado = false;
      }
    }
  }

  validate(): void{
    switch(this.passo_atual){
      case 'documento':
        this.validateDocumento();
        break;
      case 'variaveis':
        break;
      case 'corpo':
        break;
    }
  }

  validateDocumento(): void{
    if(this.documento.nome === undefined || this.documento.nome === null){

    } else {

    }

    if(this.documento.descricao === undefined || this.documento.nome === null){

    } else{

    }

    if(this.documento.certificado.tipo === undefined || this.documento.certificado.tipo === null){

    } else {

    }
  }

  ngOnInit() {
    this.getDocumento();
    this.getTipos();
    this.getTipoCertificados();
    this.getCentros();
    this.getGrupos();
  }

  ngAfterViewChecked() {
    Materialize.updateTextFields();
  }

}



// WEBPACK FOOTER //
// ./src/app/documentos/editar.component.ts